import * as React from "react";

interface Props {
    columns: Array<string>;
    renderHeader?: (column: string) => React.ReactNode;
    columnClasses: Record<string, string>;
}

export default class ReportTableHeader extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <thead className="report-table-header">
                <tr>
                    {this.props.columns.map(column => {
                        if(this.props.renderHeader) {
                            return this.props.renderHeader(column);
                        }

                        const className = this.props.columnClasses[column] || "";

                        return <th key={column} className={className}>{column}</th>;
                    })}
                </tr>
            </thead>
        );
    }
}
